var _excluded = ["children", "variant", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import InverseContext from '../../../../utilities/inverse-context';
import PropTypes from 'prop-types';
import StyledTileFooter from './tile.footer.styles';
import { TileContext } from '../../tile-context';
import useTile from '../../tile.hook';
var propTypes = {
  /**
   * Footer's child elements
   */
  children: PropTypes.node,
  /** Padding for Footer  */
  density: PropTypes.oneOf(['comfortable', 'compact']),
  /** Tile Footer background color */
  variant: PropTypes.oneOf(['default', 'gray', 'cool-gray', 'white', 'dark', 'brand', 'transparent']),
  /** Places child elements flush to the edges */
  isFlush: PropTypes.bool,
  /** Add utility objects for styling */
  utils: PropTypes.object
};
var defaultProps = {
  children: /*#__PURE__*/React.createElement(React.Fragment, null),
  density: 'comfortable',
  variant: 'default',
  isFlush: false,
  utils: {}
};
var TileFooter = function TileFooter(_ref) {
  var children = _ref.children,
    variantProp = _ref.variant,
    utils = _ref.utils,
    other = _objectWithoutProperties(_ref, _excluded);
  // Use inherited variant from Tile parent if Tile.Footer variant is 'default'.
  var _useTile = useTile(TileContext, {
      variant: variantProp
    }),
    onRefSet = _useTile.onRefSet,
    variant = _useTile.variant;
  var useIsInverse = useContext(InverseContext);
  return /*#__PURE__*/React.createElement(StyledTileFooter, _extends({}, other, {
    ref: onRefSet,
    utils: utils,
    variant: variant
  }), /*#__PURE__*/React.createElement(InverseContext.Provider, {
    value: variant === 'brand' || variant === 'dark' || variant === 'default' && useIsInverse
  }, children));
};
TileFooter.propTypes = propTypes;
TileFooter.defaultProps = defaultProps;
TileFooter.displayName = 'Tile.Footer';
export default TileFooter;